var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftTopIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3074 4.08962L8.89816 5.45039C8.49142 6.8844 7.13175 7.88667 5.71784 8.23746C3.92431 8.66921 0.581293 8.26445 0.0660887 6.15583C-0.452989 4.04721 2.32059 2.15062 4.11025 1.71887C5.52416 1.36808 7.20922 1.63792 8.21251 2.72114L17.3274 0.0844028C18.412 -0.239407 19.5819 0.381228 19.9111 1.46445C20.2636 2.62477 19.5276 3.84291 18.3074 4.08576",
    fill: "#A26128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55108 11.2906C5.55108 10.8318 5.17146 10.4502 4.68337 10.4502C4.2224 10.4502 3.84277 10.828 3.84277 11.2906C3.84277 11.7531 4.2224 12.1309 4.68337 12.1309C5.17146 12.1309 5.55108 11.7531 5.55108 11.2906Z",
    fill: "#A26128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4968 16.1595C5.4968 15.7007 5.11718 15.3191 4.65233 15.3191C4.18749 15.3191 3.80786 15.6969 3.80786 16.1595C3.80786 16.622 4.18749 16.9998 4.65233 16.9998C5.11718 16.9998 5.4968 16.622 5.4968 16.1595Z",
    fill: "#A26128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50388 13.3763C6.50388 12.9175 6.12426 12.5359 5.65941 12.5359C5.19457 12.5359 4.81494 12.9137 4.81494 13.3763C4.81494 13.8388 5.19457 14.2166 5.65941 14.2166C6.12426 14.2166 6.50388 13.8388 6.50388 13.3763Z",
    fill: "#A26128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4863 13.9429C3.4863 13.4842 3.10668 13.1025 2.64183 13.1025C2.17699 13.1025 1.79736 13.4803 1.79736 13.9429C1.79736 14.4055 2.17699 14.7833 2.64183 14.7833C3.10668 14.7833 3.4863 14.4055 3.4863 13.9429Z",
    fill: "#A26128"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17,
    fill: "white",
    transform: "translate(0 -0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftTopIconActive);
export default __webpack_public_path__ + "static/media/left_top_icon_active.566abb345620ff83128f57b9f410efdd.svg";
export { ForwardRef as ReactComponent };